import { ISelectOption } from '../../react-select/select-option.interface';

export class MenuSelectOption implements ISelectOption {
    constructor(public id: string, public propertyValue: string, public label: string) {
    }
}
